/**
 * Perfume Luxury Theme — Main JavaScript
 * Handles: Header (scroll, transparent, search), Mobile Menu, Cart Drawer (AJAX), Animations
 */

document.addEventListener('DOMContentLoaded', () => {

    /* =================================================================
       HEADER — Scroll Effect + Transparent Logic
    ================================================================= */
    const header = document.getElementById('SiteHeader');
    if (header) {
        let lastScroll = 0;
        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;
            if (scrollY > 60) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
            lastScroll = scrollY;
        }, { passive: true });
    }

    /* =================================================================
       SEARCH MODAL — handled by inline script in header.liquid
       This section is kept for backward compatibility
    ================================================================= */
    // Search is handled by the inline script in header.liquid
    // using SearchModal, SearchModalOverlay, SearchClose IDs


    /* =================================================================
       MOBILE MENU
    ================================================================= */
    const mobileToggle = document.getElementById('MobileMenuToggle');
    const mobileNav = document.getElementById('MobileNav');

    if (mobileToggle && mobileNav) {
        mobileToggle.addEventListener('click', () => {
            const isOpen = mobileNav.classList.toggle('is-active');
            mobileToggle.setAttribute('aria-expanded', isOpen);
            document.body.style.overflow = isOpen ? 'hidden' : '';
        });

        // Expand/collapse submenu
        mobileNav.querySelectorAll('.mobile-nav__expand').forEach(btn => {
            btn.addEventListener('click', () => {
                const submenu = btn.closest('.mobile-nav__item').querySelector('.mobile-nav__submenu');
                if (submenu) {
                    submenu.classList.toggle('is-open');
                    btn.classList.toggle('is-open');
                }
            });
        });
    }

    /* =================================================================
       CART DRAWER
    ================================================================= */
    const cartDrawerHTML = `
    <div class="cart-drawer-overlay" id="CartDrawerOverlay"></div>
    <div class="cart-drawer" id="CartDrawer">
      <div class="cart-drawer__header">
        <h3>Shopping Bag</h3>
        <button class="cart-drawer__close" id="CartDrawerClose" aria-label="Close cart">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="cart-drawer__body" id="CartDrawerBody">
        <div class="cart-drawer__empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ddd" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>Your bag is empty</p>
          <a href="/collections/all" class="btn btn-outline" style="font-size:0.8rem;padding:0.8rem 2rem;">Continue Shopping</a>
        </div>
      </div>
      <div class="cart-drawer__footer" id="CartDrawerFooter" style="display: none;">
        <div class="cart-drawer__subtotal">
          <span>Subtotal</span>
          <span id="CartDrawerTotal"></span>
        </div>
        <p class="cart-drawer__note">Shipping & taxes calculated at checkout</p>
        <a href="/checkout" class="btn cart-drawer__checkout">Checkout</a>
        <a href="{{ routes.cart_url }}" class="cart-drawer__viewcart">View Cart</a>
      </div>
    </div>
  `;
    document.body.insertAdjacentHTML('beforeend', cartDrawerHTML);

    const cartOverlay = document.getElementById('CartDrawerOverlay');
    const cartDrawer = document.getElementById('CartDrawer');
    const cartDrawerClose = document.getElementById('CartDrawerClose');
    const cartDrawerBody = document.getElementById('CartDrawerBody');
    const cartDrawerFooter = document.getElementById('CartDrawerFooter');
    const cartDrawerTotal = document.getElementById('CartDrawerTotal');
    const cartIcon = document.getElementById('CartIcon');
    const cartCount = document.getElementById('CartCount');

    function openCartDrawer() {
        cartOverlay?.classList.add('active');
        cartDrawer?.classList.add('active');
        document.body.style.overflow = 'hidden';
        fetchCart();
    }
    function closeCartDrawer() {
        cartOverlay?.classList.remove('active');
        cartDrawer?.classList.remove('active');
        document.body.style.overflow = '';
    }

    cartIcon?.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(); });
    cartDrawerClose?.addEventListener('click', closeCartDrawer);
    cartOverlay?.addEventListener('click', closeCartDrawer);

    function formatMoney(cents) {
        return (cents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD'
        });
    }

    function fetchCart() {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => renderCartDrawer(cart))
            .catch(err => console.error('Cart error:', err));
    }

    function renderCartDrawer(cart) {
        if (cart.item_count === 0) {
            cartDrawerBody.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ddd" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>Your bag is empty</p>
        </div>`;
            cartDrawerFooter.style.display = 'none';
        } else {
            let html = '';
            cart.items.forEach(item => {
                const img = item.featured_image?.url ? item.featured_image.url.replace(/(\.\w+)(\?.*)?$/, '_200x$1') : '';
                html += `
          <div class="cart-drawer-item">
            ${img ? `<a href="${item.url}" class="cart-drawer-item__img"><img src="${img}" alt="${item.title}" width="80" height="100"></a>` : ''}
            <div class="cart-drawer-item__info">
              <a href="${item.url}" class="cart-drawer-item__title">${item.product_title}</a>
              ${item.variant_title ? `<span class="cart-drawer-item__variant">${item.variant_title}</span>` : ''}
              <div class="cart-drawer-item__bottom">
                <div class="cart-drawer-item__qty">
                  <button class="qty-change" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                  <span>${item.quantity}</span>
                  <button class="qty-change" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
                <span class="cart-drawer-item__price">${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
          </div>`;
            });
            cartDrawerBody.innerHTML = html;
            cartDrawerTotal.textContent = formatMoney(cart.total_price);
            cartDrawerFooter.style.display = 'block';

            // Quantity change buttons
            cartDrawerBody.querySelectorAll('.qty-change').forEach(btn => {
                btn.addEventListener('click', () => {
                    const key = btn.dataset.key;
                    const qty = parseInt(btn.dataset.qty);
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
                    })
                        .then(r => r.json())
                        .then(cart => { renderCartDrawer(cart); updateCartCount(cart.item_count); });
                });
            });
        }
        updateCartCount(cart.item_count);
    }

    function updateCartCount(count) {
        if (cartCount) {
            cartCount.textContent = count;
            cartCount.classList.toggle('is-hidden', count === 0);
        }
    }

    /* =================================================================
       ADD TO CART — AJAX
    ================================================================= */
document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const btn = form.querySelector('[type="submit"]');
    const originalText = btn?.innerHTML;
    if (btn) btn.innerHTML = '<span>Adding...</span>';

    const formData = new FormData(form);
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    formData.set('quantity', qty);

    fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
            openCartDrawer();
            if (btn) setTimeout(() => { btn.innerHTML = originalText; }, 500);
        })
        .catch(err => {
            console.error('Add to cart error:', err);
            if (btn) btn.innerHTML = originalText;
        });
}, true);

    /* =================================================================
       SCROLL FADE-IN ANIMATIONS
    ================================================================= */
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

        document.querySelectorAll('.section-padding, .hero-banner, .newsletter-section').forEach(el => {
            el.classList.add('will-animate');
            observer.observe(el);
        });
    }
});
